import { Brand as TypeBrand, createBranded } from '@deltasierra/type-utilities';
import { Auditable, HasId, ParanoidAuditable } from '../common/model/traits';
import { Upload, UploadId } from '../upload/Upload';

export type BrandId = TypeBrand<number, 'BrandId'>;
export const BrandId = createBranded<BrandId>();

export interface Brand extends HasId<BrandId>, Auditable, ParanoidAuditable {
    // Come from the model
    title: string;
    color: string | null;

    // Included by sequelize based on uploadId
    logo?: Upload;
    logoId: UploadId | null;
}
